
import { CustomerHistoryTableSortProps } from 'mobx-stores/customers/customer-history-table-store/customer-history-table-store.types';
import {
  EntityCount,
  H2,
  PaginationButtons, RatingStars, TableBodyContainer,
  TableBodyLine, TableBodyLineProps, TableContainer,
  TableHeader
} from '@touche-lts/panel-ui/dist';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'mobx-stores/store-provider';
import { useEffect } from 'react';

import { customerHistoryWidth } from './customers-store-history-table.utils'
import { PictureNameLine } from 'components'
import { useGetScrollWidth } from 'hooks/custom-hooks';
import styles from './customers-store-history-table.module.scss'

const CustomerStoreHistoryComponent = () => {
  const {
    customerHistoryTableStore: {
      triggerSearch,
      searchResults,
      isColumnMarked,
      getSortDirection,
      handleSortDirectionChange,
      searchProps,
      onSearchPropsChange,
      paginationInfo,
      onPageSelect
    },

  } = useRootStore()

  useEffect(() => {
    triggerSearch({ resetPageNumber: true })
  }, [triggerSearch])

  const {scrollX, handleScroll} = useGetScrollWidth()

  const getBodyLineCells = (
    stores
  ): TableBodyLineProps['cells'] => {
    const cells: any = [
      {
        // widthPercentage: customerHistoryWidth.id,
        widthPx: customerHistoryWidth.id,
        children:
          <span>{stores.store.id}</span>
      },
      {
        // widthPercentage: customerHistoryWidth.stores,
        widthPx: customerHistoryWidth.stores,
        children:
          <PictureNameLine
            imageSrc={stores.store.images[0]?.url}
            imageBoxShadow
            name={stores.store.name}
          />
      },
      {
        // widthPercentage: customerHistoryWidth.email,
        widthPx: customerHistoryWidth.email,
        children: <span>{stores.store.email}</span>
      },
      {
        // widthPercentage: customerHistoryWidth.ratings,
        widthPx: customerHistoryWidth.ratings,
        children: <RatingStars rating={stores.store.rating} />
      },
      {
        // widthPercentage: customerHistoryWidth.activeProducts,
        widthPx: customerHistoryWidth.activeProducts,
        children:
          <EntityCount
            count={stores.activeProducts}
            entity='product'
          />
      },
      {
        // widthPercentage: customerHistoryWidth.country,
        widthPx: customerHistoryWidth.country,
        children: <span>{stores.store.address?.country}</span>
      },
      {
        // widthPercentage: customerHistoryWidth.website,
        widthPx: customerHistoryWidth.website,
        children: <span>{stores.store.websiteUrl}</span>
      },
    ]

    return cells
  },

    tableColumns = [
      {
        label: 'Id',
        // widthPercentage: customerHistoryWidth.id,
        widthPx: customerHistoryWidth.id,
        isColumnMarked: isColumnMarked(CustomerHistoryTableSortProps.ID),
        sortDirection: getSortDirection(CustomerHistoryTableSortProps.ID),
        setSortDirection: handleSortDirectionChange(
          CustomerHistoryTableSortProps.ID
        ),
        inputProps: {
          placeholder: 'Search...',
          value: searchProps.id,
          onChange: id => onSearchPropsChange({ id })
        }
      },
      {
        label: 'Stores',
        // widthPercentage: customerHistoryWidth.stores,
        widthPx: customerHistoryWidth.stores,
        isColumnMarked: isColumnMarked(CustomerHistoryTableSortProps.STORES),
        sortDirection: getSortDirection(CustomerHistoryTableSortProps.STORES),
        setSortDirection: handleSortDirectionChange(
          CustomerHistoryTableSortProps.STORES
        ),
        inputProps: {
          placeholder: 'Search...',
          value: searchProps.stores,
          onChange: stores => onSearchPropsChange({ stores })
        }
      },
      {
        label: 'email',
        // widthPercentage: customerHistoryWidth.email,
        widthPx: customerHistoryWidth.email,
        isColumnMarked: isColumnMarked(CustomerHistoryTableSortProps.EMAIL),
        sortDirection: getSortDirection(CustomerHistoryTableSortProps.EMAIL),
        setSortDirection: handleSortDirectionChange(
          CustomerHistoryTableSortProps.EMAIL
        ),
        inputProps: {
          placeholder: 'Search...',
          value: searchProps.email,
          onChange: email => onSearchPropsChange({ email })
        }
      },
      {
        label: 'Ratings',
        // widthPercentage: customerHistoryWidth.ratings,
        widthPx: customerHistoryWidth.ratings,
        isColumnMarked: isColumnMarked(CustomerHistoryTableSortProps.RAITINGS),
        sortDirection: getSortDirection(CustomerHistoryTableSortProps.RAITINGS),
        setSortDirection: handleSortDirectionChange(
          CustomerHistoryTableSortProps.RAITINGS
        ),
        sliderFilterProps: {
          label: 'Products raitings',
          min: 0,
          max: 5,
          value: [searchProps.raitingsMin, searchProps.raitingsMax],
          onChange: ([raitingsMin, raitingsMax]) =>
            onSearchPropsChange({ raitingsMin, raitingsMax })
        }
      },
      {
        label: 'Active Products',
        // widthPercentage: customerHistoryWidth.activeProducts,
        widthPx: customerHistoryWidth.activeProducts,
        isColumnMarked: isColumnMarked(CustomerHistoryTableSortProps.ACTIVE_PRODUCTS),
        sortDirection: getSortDirection(CustomerHistoryTableSortProps.ACTIVE_PRODUCTS),
        setSortDirection: handleSortDirectionChange(
          CustomerHistoryTableSortProps.ACTIVE_PRODUCTS
        ),
      },
      {
        label: 'Country',
        // widthPercentage: customerHistoryWidth.country,
        widthPx: customerHistoryWidth.country,
        isColumnMarked: isColumnMarked(CustomerHistoryTableSortProps.COUNTRY),
        sortDirection: getSortDirection(CustomerHistoryTableSortProps.COUNTRY),
        setSortDirection: handleSortDirectionChange(
          CustomerHistoryTableSortProps.COUNTRY
        ),
        inputProps: {
          placeholder: 'Search...',
          value: searchProps.country,
          onChange: country => onSearchPropsChange({ country })
        }
      },
      {
        label: 'Website',
        // widthPercentage: customerHistoryWidth.website,
        widthPx: customerHistoryWidth.website,
        isColumnMarked: isColumnMarked(CustomerHistoryTableSortProps.WEBSITE),
        sortDirection: getSortDirection(CustomerHistoryTableSortProps.WEBSITE),
        setSortDirection: handleSortDirectionChange(
          CustomerHistoryTableSortProps.WEBSITE
        ),
        inputProps: {
          placeholder: 'Search...',
          value: searchProps.website,
          onChange: website => onSearchPropsChange({ website })
        }
      },
    ]
  return (

    <TableContainer style={{
      maxHeight: "770px",
      height: "770px",
      marginTop: 20,
      overflowX: 'auto'
    }} className={styles.thinScroll} onScroll={handleScroll} >
      <div style={{ padding: 25 }}>
        <H2 style={{ paddingBottom: 10 }}>Stores visited</H2>
        <TableHeader tableColumns={tableColumns} />
        <TableBodyContainer className={styles.tableBodyContainer}>
          {searchResults.map((stores) => {
            return (
              <TableBodyLine cells={getBodyLineCells(stores)} />
            )
          })}
        </TableBodyContainer>
        <PaginationButtons alwaysShow {...paginationInfo}  onPageSelect={onPageSelect} style={{width : scrollX === '100%' ? "100%" : "168%" }}/>
      </div>
    </TableContainer>
  )
},

  CustomerHistoryTable = observer(CustomerStoreHistoryComponent)
export { CustomerHistoryTable };
